import {sendEvent} from '@github-ui/hydro-analytics'
import {useUpdateSubscriptionMutation} from '../mutations/use-update-subscription-mutation'
import {useLayoutQuery} from '../page-data/loaders/use-layout-query'
import {IconButton} from '@primer/react'
import {BellFillIcon, BellIcon} from '@primer/octicons-react'
import {FailureDialog} from './FailureDialog'
import styles from './SubscribeButton.module.css'
import {clsx} from 'clsx'

export function SubscribeButton() {
  const {user, notificationSubscriptionThreadId} = useLayoutQuery().data

  const mutation = useUpdateSubscriptionMutation()
  const optimisticSubscribed = !user.ignoringRepository && (mutation.isPending ? mutation.variables : user.subscribed)

  if (!user || !notificationSubscriptionThreadId) return null

  const toggleSubscription = () => {
    if (user.ignoringRepository) return

    const newSubscribed = !optimisticSubscribed
    sendEvent('notifications.thread_subscription.toggle', {
      subscriptionState: newSubscribed ? 'SUBSCRIBED' : 'UNSUBSCRIBED',
      threadClass: 'PullRequest',
    })

    mutation.mutate(newSubscribed)
  }

  return (
    <>
      <IconButton
        onClick={toggleSubscription}
        icon={
          optimisticSubscribed ? (
            <BellFillIcon className={clsx((mutation.isPending || mutation.isSuccess) && styles.animateBell)} />
          ) : (
            <BellIcon />
          )
        }
        aria-label={optimisticSubscribed ? 'Unsubscribe' : 'Subscribe'}
        aria-disabled={user.ignoringRepository}
        description={
          user.ignoringRepository
            ? "You're ignoring this repository, so you cannot subscribe to this pull request."
            : undefined
        }
      />
      {mutation.isError && (
        <FailureDialog
          title={mutation.variables ? 'Failed to subscribe' : 'Failed to unsubscribe'}
          message={
            mutation.variables
              ? 'Failed to subscribe to this pull request. Please try again.'
              : 'Failed to unsubscribe from this pull request. Please try again.'
          }
          details={mutation.error.message}
          onRetry={() => mutation.mutate(mutation.variables)}
          onDismiss={() => mutation.reset()}
        />
      )}
    </>
  )
}
